import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { ParliamentChart } from './parliamentChart'
import { ParliamentTable } from './parliamentTable'
import './style.scss'
import {
  SeatsPerParty,
  JSONFileSeatDistribution
} from 'types/gemeindeRatSitzeFile'
import { Header } from 'components/header'

export default function index(): ReactElement {
  const [data, setData] = useState({
    meta: {
      title: 'Voici la nouvelle répartition des sièges au Grand Conseil'
    },
    seatsPerParty: [
      {
        changeSeats: 1,
        color: '#3872b5',
        orderFromLeftToRight: 5,
        party: 'PLR',
        seats: 50
      },
      {
        changeSeats: -5,
        color: '#f0554d',
        orderFromLeftToRight: 1,
        party: 'PS',
        seats: 32
      },
      {
        changeSeats: 4,
        color: '#84b547',
        orderFromLeftToRight: 2,
        party: 'Les Verts',
        seats: 25
      },
      {
        changeSeats: -2,
        color: '#4b8a3e',
        orderFromLeftToRight: 6,
        party: 'UDC',
        seats: 23
      },
      {
        changeSeats: +4,
        color: '#c4c43d',
        orderFromLeftToRight: 4,
        party: "vert'lib",
        seats: 11
      },
      {
        changeSeats: 2,
        color: '#ad4f89',
        orderFromLeftToRight: 0,
        party: 'EàG/POP/Sol',
        seats: 7
      },
      {
        changeSeats: -2,
        color: '#9d9d9d',
        orderFromLeftToRight: 3,
        party: 'Les Libres',
        seats: 2
      },
      {
        changeSeats: -2,
        color: '#deaa28',
        orderFromLeftToRight: 6,
        party: 'Le Centre',
        seats: 0
      }
    ]
  })
  // useEffect(() => {
  //   fetch(
  //     'https://wch-interactive.storage.googleapis.com/votations-2022-vd/grandConseil-seats-2022-grouped.json'
  //   ).then(res =>
  //     res.json().then(data => {
  //       setData(data)
  //     })
  //   )
  // }, [])

  return (
    <>
      {data && (
        <>
          <Header
            title={data.meta.title}
            description={data.meta.description}
            doneMunicipalCouncil={data.meta.doneMunicipalCouncil}
            countStatus={data.meta.countStatus}
          />
          <ParliamentChart
            seatColorArray={data.seatsPerParty
              .sort((a, b) => a.orderFromLeftToRight - b.orderFromLeftToRight)
              .map(row => {
                return { seats: row.seats, color: row.color }
              })}
          />
          <ParliamentTable seatsPerParty={data.seatsPerParty} />
        </>
      )}
    </>
  )
}
